import Vue from 'vue';
import gql from 'graphql-tag';
import { apolloClient } from '@/plugins/vue-apollo';

const fetchAllCurrenciesQuery = gql `query {
  currencies: currency(where: {code: { _in: ["CLP", "USD", "EUR", "UF"]}}, order_by: { name: asc }){
    id
    code
    name
  },
  defaultCurrency: currency(where: { code: { _eq: "CLP" }}) {
    id
    code
    name
  }
}`;

const currency = {
  namespaced: true,
  state: {
    currencies: [],
    defaultCurrency: null,
  },
  actions: {
    async fetchAll({ commit }) {
      try {
        const requestQuery = {
          query: fetchAllCurrenciesQuery,
        };
        const result = await apolloClient.query(requestQuery);
        if (result && result.data) {
          commit('SET_CURRENCIES_LIST', result.data);
        }
      } catch (error) {
        window.console.error(error);
      }
    },
  },
  mutations: {
    SET_CURRENCIES_LIST(state, data) {
      Vue.set(state, 'currencies', data.currencies);
      Vue.set(state, 'defaultCurrency', data.defaultCurrency);
    },
  },
  getters: {
    currenciesInfo: state => state.currencies,
    defaultCurrencyInfo: state => state.defaultCurrency,
  },
};

export default currency;



// WEBPACK FOOTER //
// ./src/store/modules/core/currency.js